<script lang="ts">
    import { onMount } from 'svelte';
    import EcosystemForCategory from '../components/EcosystemForCategory.svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { getEcosystems, getEcosystemCategories } from '../scripts/apiEcosystems';
    import { 
        storeEcosystems, 
        storeEcosystemsError, 
        storeEcosystemCategories, 
        storeEcosystemCategoriesError 
    } from "../scripts/ecosystem";
    import { addNotificationError }  from "../scripts/toaster";
    import { storeLanguage, lang_fr, storeLoader } from "../scripts/store";
    import { launchLoader } from '../scripts/utils';

    onMount(async () => {
        getEcosystemsIfEmpty();
        getEcosystemCategoriesIfEmpty();
        window.scrollTo(0,0);
	});

    /**
     * getEcosystemsIfEmpty
     */
    function getEcosystemsIfEmpty() {
        if ($storeEcosystems.length <= 0) {
            launchLoader();
            const returnValue = getEcosystems();
            returnValue.then((data) => {
                storeLoader.set(false);
                if (!data) {
                    addNotificationError($storeEcosystemsError);
                };
            });
        }
    }

    /**
     * getEcosystemCategoriesIfEmpty
     */
     function getEcosystemCategoriesIfEmpty() {
        if ($storeEcosystemCategories.length <= 0) {
            const returnValue = getEcosystemCategories();
            returnValue.then((data) => {
                if (!data) {
                    addNotificationError($storeEcosystemCategoriesError);
                };
            });
        }
    }

    /**
     * handleAnchorClick
     * @param anchorId
     */
    function handleAnchorClick (anchorId) {
		const anchor = document.getElementById("anchor-"+anchorId)
		window.scrollTo({
			top: anchor.offsetTop,
			behavior: 'smooth'
		})
	}

</script>
    
<style lang="scss">

    .ecosystem {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__intro {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            &__text {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                text-align: center;
                width: 100%;
                font-size: 20px;
                margin: 60px 0 0 0;
            }
            &__contact {
                margin: 0 0 60px 0;
            }
            &__contact {
                padding: 30px 0 15px 15px;
                font-style: italic;
                font-size: 14px;
                color: $color_primary;
                align-self: flex-end;
            }
        }
        &__categories {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            margin: 0 0 60px 0;
            width: 100%;
            &__item {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border: 1px solid $color-primary;
                color: $color-primary;
                transition: all;
                transition-duration: 0.5s;
                margin: 15px 10px 15px 10px;
                padding: 5px 5px 5px 5px;
                min-width: 150px;
                cursor: pointer;
                &:hover {
                    border: 1px solid $color-orange;
                    color: $color-orange;
                    transform: scale(1.1);
                }
            }
        }
        &__tiles {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            margin: 0 0 60px 0;
        }
    }

    @include large {
        .ecosystem {
            &__categories {
                width: 75%;
            }
        }
    }

</style>

<div class="ecosystem">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="écosystème apis"/>
    {:else}
    <PageHeader props="API ecosystem"/>
    {/if}
    <div class="bloc ecosystem__bloc">
        <div class="ecosystem__intro">
            <div class="ecosystem__intro__text">
                {#if ($storeLanguage == $lang_fr)}
                L’écosystème des APIs en France est riche !<br>
                Nous avons recensé toutes les entreprises fournisseurs de solutions autour des APIs.<br>
                Si vous constatez un oubli, une erreur ou si vous voulez rejoindre ce panorama, écrivez-nous !    
                {:else}
                The ecosystem of APIs in France is rich!<br>
                We have identified all the companies providing solutions around APIs.<br>
                If you notice an omission, an error or if you want to join this panorama, write to us!
                {/if}
            </div>
            <div class="ecosystem__intro__contact">
                {#if ($storeLanguage == $lang_fr)}
                N'hésitez pas à nous contacter à l'adresse indiquée dans le pied de page
                {:else}
                Do not hesitate to contact us at the address indicated in the footer
                {/if}
            </div>
        </div>
        <div class="ecosystem__categories">
            {#if ($storeEcosystemCategoriesError != "")}
                <div class="getallarticles__article getallarticles__error">
                    <p>Error : {$storeEcosystemCategoriesError}</p>
                </div>
            {:else}
                {#each $storeEcosystemCategories as ecosystemCategory}
                <div class="ecosystem__categories__item" on:click={() => handleAnchorClick(ecosystemCategory.id)} on:keydown={() => handleAnchorClick(ecosystemCategory.id)}>
                    {#if ($storeLanguage == $lang_fr)}
                    {ecosystemCategory.label_fr}
                    {:else}
                    {ecosystemCategory.label_en}
                    {/if}
                </div>
                {/each}
            {/if}
        </div>

        <div class="ecosystem__tiles">
            {#each $storeEcosystemCategories as ecosystemCategory}
            <div class="ecosystem__anchor" id="anchor-{ecosystemCategory.id}"></div>
            <EcosystemForCategory props={ecosystemCategory} />
            {/each}
        </div>    
    </div>
</div>
